import React, { memo } from "react";
import useHeroSection from "./index.hooks";
import { Box, Container, Typography } from "@material-ui/core";
import cn from "classnames";

type HeroSectionProps = {
  hasBgImg: boolean;
  headline: string;
  description: string;
  img: string;
  isCut: boolean;
  alt: string;
  imgStart: string;
};

const HeroSection = ({
  hasBgImg,
  headline,
  description,
  img,
  isCut,
  alt,
  imgStart,
}: HeroSectionProps) => {
  const { styles, classes, atomicStyles } = useHeroSection();

  return (
    <div className={hasBgImg ? styles.darkSection : styles.lightSection}>
      <Container
        className={
          imgStart ? styles.reversedContainer : styles.straightContainer
        }
        maxWidth="lg"
      >
        <Box className={styles.textBox}>
          <Typography
            className={hasBgImg ? styles.lightText : styles.darkText}
            component="h1"
            variant="h2"
            gutterBottom
          >
            {headline}
          </Typography>
          <Typography
            className={hasBgImg ? styles.lightText : styles.darkText}
            variant="h6"
          >
            {description}
          </Typography>
        </Box>
        <img
          src={img}
          alt={alt}
          className={cn(
            isCut ? styles.imageCut : styles.imageFull,
            imgStart ? styles.imageLeft : styles.imageRight,
          )}
        />
      </Container>
    </div>
  );
};

export default memo(HeroSection);
